<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)" autocomplete="off">
      <v-card
        flat
        width="100%"
        class="verify-code">
        <v-card-text
          class="black--text px-0 mb-2">
          Ingresa la contraseña para tu cuenta de usuario
          <input type="text" autocomplete="username" :value="email" style="display: none">
        </v-card-text>
        <!-- password -->
        <ValidationProvider
          mode="eager"
          vid="new_password"
          name="auth.new_password"
          rules="required"
          v-slot="{ errors }">
          <v-text-field
            filled
            flat
            :disabled="waiting"
            :maxlength="100"
            name="email"
            v-model="password"
            :error-messages="errors[0]"
            class="password"
            label="Nueva contraseña"
            type="password"
            autocomplete="off"
            autofocus>
          </v-text-field>
        </ValidationProvider>
        <!-- confirm password -->
        <ValidationProvider
          mode="eager"
          vid="confirm_password"
          name="auth.confirm_password"
          rules="required"
          v-slot="{ errors }">
          <v-text-field
            filled
            flat
            :disabled="waiting"
            :maxlength="100"
            name="email"
            v-model="confirmPassword"
            :error-messages="errors[0]"
            class="password"
            label="Confirmar contraseña"
            type="password"
            autocomplete="off">
          </v-text-field>
        </ValidationProvider>
        <v-card-actions
          class="px-0">
          <v-spacer></v-spacer>
          <v-btn
            text
            class="grey--text px-10"
            :disabled="waiting"
            @click="cancel">
            Cancelar
          </v-btn>
          <v-btn
            type="submit"
            class="brand-purple white--text px-10"
            :loading="waiting">
            Actualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </ValidationObserver>
</template>

<script>

import { mapActions } from 'vuex';

import Utils from '@/Utils';
import loginController from '@/controllers/Login';

export default {
  name: 'EnterPassword',
  props: {
    email: {
      default: null,
    },
    exists: {
      default: false,
    },
    verificationCode: {
      default: null,
    },
  },
  data() {
    return {
      waiting: false,
      password: null,
      confirmPassword: null,
      code: this.verificationCode,
    };
  },
  created() {
    // when 'code' is null, generate a new one because it is auto-verified
    if (!this.code) {
      loginController.generateCode(this.email, 'user_register', true, true)
        .then((response) => {
          this.code = response.data.code;
        });
    }
  },
  methods: {
    ...mapActions('app/', ['closeLogin']),
    cancel() {
      this.$emit('canceled');
    },
    submit() {
      this.waiting = true;
      const {
        email,
        password,
        confirmPassword,
        code,
      } = this;
      let promise;
      if (this.exists) {
        promise = this.changePassword(email, password, confirmPassword, code);
      } else {
        promise = this.createUser(email, password, confirmPassword, code);
      }
      promise
        .then(() => {
          if (this.exists) {
            Utils.trackEvent('Login');
          } else {
            Utils.trackEvent('UserRegistered');
          }
          // vue login / check auth/index.js -> Vue.use(VueAuth -> response(res)
          // check for an "action" in "state" query param sent by provider
          this.$auth.login({ rememberMe: true, redirect: null });
          // close modal
          this.$nextTick(async () => {
            await this.$waitFor(2000);
            this.closeLogin();
          });
          // emit event
          this.$emit('changed');
        })
        .catch((e) => {
          this.handleError(e);
        })
        .then(() => {
          this.waiting = false;
        });
    },
    changePassword(email, password, confirmPassword, code) {
      return loginController.changePassword(email, password, confirmPassword, code);
    },
    createUser(email, password, confirmPassword, code) {
      return loginController.register(email, password, confirmPassword, code);
    },
    handleError(e) {
      const errorInfo = e.response.data;
      const { innerErrors } = errorInfo;
      // eslint-disable-next-line no-prototype-builtins
      const newPasswordError = innerErrors?.hasOwnProperty('auth.new_password');
      if (newPasswordError) {
        this.$error(`
          <div>La contraseña debe cumplir con los siguientes requisitos:</div>
          <ul>
            ${innerErrors['auth.new_password'].map((p) => `<li>${p}</li>`).join('')}
          </ul>
        `, null, 10000);
      } else {
        this.$error(e);
      }
    },
  },
};
</script>
